import { render, staticRenderFns } from "./HolidaysView.vue?vue&type=template&id=c8dd0316&"
import script from "./HolidaysView.vue?vue&type=script&lang=js&"
export * from "./HolidaysView.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysView.vue?vue&type=style&index=0&id=c8dd0316&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports